import actions from "./actions";

const initState = {
    iqRequestResult: [],
    loading: false,
    error: null,
    buttonLoading: false,
};

export default function reducer(state = initState, action) {
    switch (action.type) {
        case actions.GET_IQ_REQUEST_REPORT:
            return {
                ...state,
                loading: true,
                error: null,
                buttonLoading :true
            };
        case actions.GET_IQ_REQUEST_REPORT_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                iqRequestResult: action.iqRequestResult,
                buttonLoading :false
            };
        case actions.GET_IQ_REQUEST_REPORT_FAILED:
            return {
                ...state,
                loading: false,
                error: action.error,
                buttonLoading :false
            };
        default:
            return state;
    }
}